class $c2455c937b104e74$export$2e2bcd8739ae039 {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
    add(v) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x + v.x, this.y + v.y);
    }
    addTo(v) {
        this.x += v.x;
        this.y += v.y;
    }
    sub(v) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x - v.x, this.y - v.y);
    }
    subFrom(v) {
        this.x -= v.x;
        this.y -= v.y;
    }
    mult(n) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x * n, this.y * n);
    }
    div(n) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x / n, this.y / n);
    }
    setAngle(angle) {
        var length = this.getLength();
        this.x = Math.cos(angle) * length;
        this.y = Math.sin(angle) * length;
        return this;
    }
    setLength(length) {
        var angle = this.getAngle();
        this.x = Math.cos(angle) * length;
        this.y = Math.sin(angle) * length;
        return this;
    }
    getAngle() {
        return Math.atan2(this.y, this.x);
    }
    getLength() {
        return Math.hypot(this.x, this.y);
    }
    getLengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    distanceTo(v) {
        return this.sub(v).getLength();
    }
    distanceToSq(v) {
        return this.sub(v).getLengthSq();
    }
    copy() {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x, this.y);
    }
    rotate(angle) {
        return new $c2455c937b104e74$export$2e2bcd8739ae039(this.x * Math.cos(angle) - this.y * Math.sin(angle), this.x * Math.sin(angle) + this.y * Math.cos(angle));
    }
    rotateAround(v, angle) {
        let x = (this.x - v.x) * Math.cos(angle) - (v.y - this.y) * Math.sin(angle) + v.x;
        let y = (v.y - this.y) * Math.cos(angle) + (this.x - v.x) * Math.sin(angle) + v.y;
        return new $c2455c937b104e74$export$2e2bcd8739ae039(x, y);
    }
    lerp(v, t) {
        let delta = v.sub(this).mult(t);
        return this.add(delta);
    }
    lerpTo(v, t) {
        let delta = v.sub(this).mult(t);
        this.addTo(delta);
    }
    moveTowards(v, length) {
        let delta = v.sub(this).setLength(length);
        return this.add(delta);
    }
    equals(v) {
        return this.x == v.x && this.y == v.y;
    }
}


class $066d4610ee08afca$export$2e2bcd8739ae039 {
    constructor(a, b, c){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    vertexes() {
        return [
            this.a,
            this.b,
            this.c
        ];
    }
    vertexesAsString() {
        return this.vertexes().map((vertex)=>`${vertex.x}, ${vertex.y}`).join(", ");
    }
    edges() {
        return [
            [
                this.a,
                this.b
            ],
            [
                this.b,
                this.c
            ],
            [
                this.c,
                this.a
            ]
        ];
    }
    sharesAVertexWith(triangle) {
        // TODO: optimize me please!
        for(let i = 0; i < 3; i++)for(let j = 0; j < 3; j++){
            let v = this.vertexes()[i];
            let vv = triangle.vertexes()[j];
            if (v.equals(vv)) return true;
        }
        return false;
    }
    hasEdge(edge) {
        for(let i = 0; i < 3; i++){
            let e = this.edges()[i];
            if (e[0].equals(edge[0]) && e[1].equals(edge[1]) || e[1].equals(edge[0]) && e[0].equals(edge[1])) return true;
        }
        return false;
    }
    get circumcenter() {
        if (!this._circumcenter) {
            let d = 2 * (this.a.x * (this.b.y - this.c.y) + this.b.x * (this.c.y - this.a.y) + this.c.x * (this.a.y - this.b.y));
            let x = 1 / d * ((this.a.x * this.a.x + this.a.y * this.a.y) * (this.b.y - this.c.y) + (this.b.x * this.b.x + this.b.y * this.b.y) * (this.c.y - this.a.y) + (this.c.x * this.c.x + this.c.y * this.c.y) * (this.a.y - this.b.y));
            let y = 1 / d * ((this.a.x * this.a.x + this.a.y * this.a.y) * (this.c.x - this.b.x) + (this.b.x * this.b.x + this.b.y * this.b.y) * (this.a.x - this.c.x) + (this.c.x * this.c.x + this.c.y * this.c.y) * (this.b.x - this.a.x));
            this._circumcenter = new (0, $c2455c937b104e74$export$2e2bcd8739ae039)(x, y);
        }
        return this._circumcenter;
    }
    get centroid() {
        if (!this._centroid) this._centroid = this.a.add(this.b).add(this.c).div(3);
        return this._centroid;
    }
    get circumradius() {
        if (!this._circumradius) this._circumradius = this.circumcenter.sub(this.a).getLength();
        return this._circumradius;
    }
    pointIsInsideCircumcircle(point) {
        let dist = point.sub(this.circumcenter).getLength();
        return dist < this.circumradius;
    }
}


function $a670ff9246d9bd8a$export$2e2bcd8739ae039(superTriangle, pointList) {
    // pointList is a set of coordinates defining the 
    // points to be triangulated
    let triangulation = [];
    // add super-triangle to triangulation 
    // must be large enough to completely contain all 
    // the points in pointList
    triangulation.push(superTriangle);
    // add all the points one at a time to the triangulation
    pointList.forEach((point)=>{
        let badTriangles = [];
        // first find all the triangles that are no 
        // longer valid due to the insertion
        triangulation.forEach((triangle)=>{
            if (triangle.pointIsInsideCircumcircle(point)) badTriangles.push(triangle);
        });
        let polygon = [];
        // find the boundary of the polygonal hole
        badTriangles.forEach((triangle)=>{
            triangle.edges().forEach((edge)=>{
                let edgeIsShared = false;
                badTriangles.forEach((otherTriangle)=>{
                    if (triangle !== otherTriangle && otherTriangle.hasEdge(edge)) edgeIsShared = true;
                });
                if (!edgeIsShared) //edge is not shared by any other 
                // triangles in badTriangles
                polygon.push(edge);
            });
        });
        // remove them from the data structure
        badTriangles.forEach((triangle)=>{
            let index = triangulation.indexOf(triangle);
            if (index > -1) triangulation.splice(index, 1);
        });
        // re-triangulate the polygonal hole
        polygon.forEach((edge)=>{
            //form a triangle from edge to point
            let newTri = new (0, $066d4610ee08afca$export$2e2bcd8739ae039)(edge[0], edge[1], point);
            triangulation.push(newTri);
        });
    });
    // done inserting points, now clean up
    let i = triangulation.length;
    while(i--){
        let triangle = triangulation[i];
        if (triangle.sharesAVertexWith(superTriangle)) {
            //remove triangle from triangulation
            let index = triangulation.indexOf(triangle);
            if (index > -1) triangulation.splice(index, 1);
        }
    }
    return triangulation;
}






let $c1ce9d969bfa6909$var$canvas;
let $c1ce9d969bfa6909$var$ctx;
let $c1ce9d969bfa6909$var$w, $c1ce9d969bfa6909$var$h;
let $c1ce9d969bfa6909$var$colors;
let $c1ce9d969bfa6909$var$colorSchemeIndex;
function $c1ce9d969bfa6909$var$setup() {
    $c1ce9d969bfa6909$var$setupColors();
    $c1ce9d969bfa6909$var$canvas = document.querySelector("#canvas");
    $c1ce9d969bfa6909$var$ctx = $c1ce9d969bfa6909$var$canvas.getContext("2d");
    $c1ce9d969bfa6909$var$reset();
    window.addEventListener("resize", $c1ce9d969bfa6909$var$reset);
    $c1ce9d969bfa6909$var$canvas.addEventListener("click", $c1ce9d969bfa6909$var$draw);
}
function $c1ce9d969bfa6909$var$setupColors() {
    $c1ce9d969bfa6909$var$colors = [
        [
            "#ffcdb2",
            "#ffb4a2",
            "#e5989b",
            "#b5838d",
            "#6d6875"
        ],
        [
            "#9c89b8",
            "#f0a6ca",
            "#efc3e6",
            "#f0e6ef",
            "#b8bedd"
        ],
        [
            "#7bdff2",
            "#b2f7ef",
            "#eff7f6",
            "#f7d6e0",
            "#f2b5d4"
        ],
        [
            "#cc5803",
            "#e2711d",
            "#ff9505",
            "#ffb627",
            "#ffc971"
        ],
        [
            "#d8e2dc",
            "#ffe5d9",
            "#ffcad4",
            "#f4acb7",
            "#9d8189"
        ],
        [
            "#05668d",
            "#028090",
            "#00a896",
            "#02c39a",
            "#f0f3bd"
        ],
        [
            "#9c89b8",
            "#f0a6ca",
            "#efc3e6",
            "#f0e6ef",
            "#b8bedd"
        ],
        [
            "#fbfbf2",
            "#e5e6e4",
            "#cfd2cd",
            "#a6a2a2",
            "#847577"
        ]
    ];
}
function $c1ce9d969bfa6909$var$getRandomColor() {
    let len = $c1ce9d969bfa6909$var$colors[$c1ce9d969bfa6909$var$colorSchemeIndex].length;
    let randomIndex = Math.floor(Math.random() * len);
    return $c1ce9d969bfa6909$var$colors[$c1ce9d969bfa6909$var$colorSchemeIndex][randomIndex];
}
function $c1ce9d969bfa6909$var$getRandomPoints() {
    let extra = 50;
    let pointList = [
        new (0, $c2455c937b104e74$export$2e2bcd8739ae039)(-extra, -extra),
        new (0, $c2455c937b104e74$export$2e2bcd8739ae039)(-extra, $c1ce9d969bfa6909$var$h + extra),
        new (0, $c2455c937b104e74$export$2e2bcd8739ae039)($c1ce9d969bfa6909$var$w + extra, -extra),
        new (0, $c2455c937b104e74$export$2e2bcd8739ae039)($c1ce9d969bfa6909$var$w + extra, $c1ce9d969bfa6909$var$h + extra)
    ];
    let delimiter = Math.random() * 9000 + 1000;
    let nrOfPoints = $c1ce9d969bfa6909$var$w * $c1ce9d969bfa6909$var$h / delimiter;
    for(let i = 0; i < nrOfPoints; i++)pointList.push(new (0, $c2455c937b104e74$export$2e2bcd8739ae039)(Math.random() * ($c1ce9d969bfa6909$var$w + extra * 2) - extra, Math.random() * ($c1ce9d969bfa6909$var$h + extra * 2) - extra));
    return pointList;
}
function $c1ce9d969bfa6909$var$reset() {
    $c1ce9d969bfa6909$var$w = $c1ce9d969bfa6909$var$canvas.width = window.innerWidth;
    $c1ce9d969bfa6909$var$h = $c1ce9d969bfa6909$var$canvas.height = window.innerHeight;
    $c1ce9d969bfa6909$var$draw();
}
function $c1ce9d969bfa6909$var$draw() {
    let nrOfColorSchemes = $c1ce9d969bfa6909$var$colors.length;
    $c1ce9d969bfa6909$var$colorSchemeIndex = Math.floor(Math.random() * nrOfColorSchemes);
    $c1ce9d969bfa6909$var$ctx.fillStyle = $c1ce9d969bfa6909$var$getRandomColor();
    $c1ce9d969bfa6909$var$ctx.fillRect(0, 0, $c1ce9d969bfa6909$var$w, $c1ce9d969bfa6909$var$h);
    let superTriangle = new (0, $066d4610ee08afca$export$2e2bcd8739ae039)(new (0, $c2455c937b104e74$export$2e2bcd8739ae039)(-$c1ce9d969bfa6909$var$w * 10, $c1ce9d969bfa6909$var$h * 10), new (0, $c2455c937b104e74$export$2e2bcd8739ae039)($c1ce9d969bfa6909$var$w * 10, $c1ce9d969bfa6909$var$h * 10), new (0, $c2455c937b104e74$export$2e2bcd8739ae039)($c1ce9d969bfa6909$var$w / 2, -$c1ce9d969bfa6909$var$h * 10));
    let pointList = $c1ce9d969bfa6909$var$getRandomPoints();
    let triangles = (0, $a670ff9246d9bd8a$export$2e2bcd8739ae039)(superTriangle, pointList);
    triangles.forEach((t)=>{
        let col = $c1ce9d969bfa6909$var$getRandomColor();
        $c1ce9d969bfa6909$var$ctx.strokeStyle = col;
        $c1ce9d969bfa6909$var$ctx.fillStyle = col;
        $c1ce9d969bfa6909$var$ctx.beginPath();
        $c1ce9d969bfa6909$var$ctx.lineTo(t.a.x, t.a.y);
        $c1ce9d969bfa6909$var$ctx.lineTo(t.b.x, t.b.y);
        $c1ce9d969bfa6909$var$ctx.lineTo(t.c.x, t.c.y);
        $c1ce9d969bfa6909$var$ctx.closePath();
        $c1ce9d969bfa6909$var$ctx.fill();
        $c1ce9d969bfa6909$var$ctx.stroke();
    });
}
$c1ce9d969bfa6909$var$setup();


//# sourceMappingURL=colorful-triangle-pattern.ac7319ed.js.map
